import React from 'react'

import ImageWithText from '../../components/ImageWithText'
import screenshotUrl from './screenshot.png'

const CompassScreen: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p>
        Compass is RQ's client diagnostic tool. It helps uncover gaps in your
        clients’ financial health and spot referral opportunities— through a
        simple, structured process.
      </p>
    }
  />
)

export default CompassScreen
